import {
    useInputCompositionContext,
} from "../../../../../../../hooks/useInputCompositionContext/useInputCompositionContext";

import React, { Children, cloneElement, isValidElement } from "react";
import { v4 as uuidv4 } from "uuid";

import "./SimpleReasonDropdown.scss";

const SimpleReasonDropdown = ({
                                  setState,
                                  items,
                                  forceClose,
                                  field,
                                  setStateModel,
                                  injectMethods,
                                  children,
                                  delegation,
                              }) => {
    const [, , isError, setIsError] = useInputCompositionContext();

    function itemClickHandler(event, listItem) {
        console.log("Selected reason:", listItem);

        if (isError) {
            setIsError(prev => {
                if (prev[field]) {
                    const temp = { ...prev };
                    delete temp[field];
                    return temp;
                } else {
                    return prev;
                }
            });
        }

        // Устанавливаем displayName в состояние инпута
        setState(listItem.displayName);

        // Устанавливаем value в stateModel
        setStateModel((prev) => {
            const newState = {
                ...prev,
                [field]: listItem.value,
            };

            // Если комментарий не требуется, очищаем поле comment
            if (!listItem.commentRequired && prev.comment) {
                newState.comment = "";
            }

            return newState;
        });

        // Обновляем правила валидации
        setStateModel((prev) => {
            const newRules = { ...prev.rules };

            if (listItem.commentRequired) {
                // Добавляем правило для комментария
                newRules.comment = ["notEmpty"];
            } else {
                // Удаляем правило для комментария
                delete newRules.comment;
            }

            return {
                ...prev,
                rules: newRules,
            };
        });

        // Очищаем ошибку для поля comment, если она есть
        if (isError && isError.comment) {
            setIsError(prev => {
                const temp = { ...prev };
                delete temp.comment;
                return temp;
            });
        }

        injectMethods && injectMethods.forEach(method => {
            if (method) {
                if (method.dispatch) {
                    method.dispatch(method.call(listItem.value));
                } else {
                    method.call();
                }
            }
        });

        forceClose();
    }

    console.log("SimpleReasonDropdown items:", items);

    if (!items) {
        return (
            <ul className="simple-dropdown-default">
                <li className="simple-dropdown-default__empty-item"><div></div></li>
                <li className="simple-dropdown-default__empty-item"><div></div></li>
                <li className="simple-dropdown-default__empty-item"><div></div></li>
            </ul>
        );
    }

    if (items.length === 0) {
        return (
            <div className={"popup-dropdown-search__no-items"}>
                <span className={"popup-dropdown-search__no-items__text"}>
                    нет причин отсутствия для выбора
                </span>
            </div>
        );
    }

    return (
        <ul className="simple-dropdown-default">
            {items.map((listItem) => {
                return (
                    <div key={uuidv4()}>
                        {children ? (
                            <div>
                                {Children && Children.map(children, (child) => {
                                    if (isValidElement(child)) {
                                        return cloneElement(child, {
                                            listItem,
                                            setState,
                                            setStateModel,
                                            field,
                                            itemClickHandler,
                                        });
                                    }
                                    return child;
                                })}
                            </div>
                        ) : (
                            <li
                                className="simple-dropdown-default__item"
                                onClick={(event) => itemClickHandler(event, listItem)}
                            >
                                {listItem.displayName}
                                {listItem.commentRequired && (
                                    <span style={{
                                        marginLeft: "8px",
                                        fontSize: "11px",
                                        color: "#999",
                                        fontStyle: "italic",
                                    }}>
                                        (требуется комментарий)
                                    </span>
                                )}
                            </li>
                        )}
                    </div>
                );
            })}
        </ul>
    );
};

export default SimpleReasonDropdown;
